var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDirections(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 7,
    viewBox: "0 0 11 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.88034 4.58304H0.624919C0.327002 4.58304 0.083252 4.82679 0.083252 5.12471C0.083252 5.42263 0.327002 5.66638 0.624919 5.66638H3.88034V6.63596C3.88034 6.87971 4.17284 6.99888 4.34075 6.82554L5.84659 5.31429C5.9495 5.20596 5.9495 5.03804 5.84659 4.92971L4.34075 3.41846C4.17284 3.24513 3.88034 3.36971 3.88034 3.60804V4.58304ZM7.1195 3.38596V2.41638H10.3749C10.6728 2.41638 10.9166 2.17263 10.9166 1.87471C10.9166 1.57679 10.6728 1.33304 10.3749 1.33304H7.1195V0.363461C7.1195 0.119711 6.827 0.000544704 6.65909 0.173878L5.15325 1.68513C5.05034 1.79346 5.05034 1.96138 5.15325 2.06971L6.65909 3.58096C6.827 3.74888 7.1195 3.62971 7.1195 3.38596Z",
    fill: "#223E7C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDirections);
export default __webpack_public_path__ + "static/media/arrow-directions.8056f126c7c8553d60f67e80cbc4eea0.svg";
export { ForwardRef as ReactComponent };